module.exports = __webpack_public_path__ + "assets/img/right_1.4aab6318.svg";